import Container, { Service } from 'typedi';
import {
    IAuthenticationResult,
    IAutoLoginModel,
    IAutoLoginResponseModel,
    IAutologinAuthenticationService,
    IEnhancedLoginResult,
} from '../models';
import { GeoLocationBrands } from '../../../models/enums/general-enums';
import { StorageItemEnum } from '../../../models/enums/storage-enums';
import { SessionSimpleStoreService } from '../../storage/implementations/simple-store';
import { UrlUtils } from '../../utils/urlUtils';
import { AuthenticationService } from './authentication.service';
import { WindowToken } from '../../../injection-tokens';
import { PokerNative } from '../../poker-native/poker-native';

@Service()
export class AutoLoginAuthenticationService implements IAutologinAuthenticationService {
    private readonly _window: Window;
    private readonly _sessionSimpleStoreService: SessionSimpleStoreService;
    private readonly _urlUtils: UrlUtils;
    private readonly _pokerNative: PokerNative;
    private readonly _authenticationService: AuthenticationService;

    constructor() {
        this._window = Container.get(WindowToken);
        this._pokerNative = Container.get(PokerNative);
        this._sessionSimpleStoreService = Container.get(SessionSimpleStoreService);
        this._urlUtils = Container.get(UrlUtils);
        this._authenticationService = Container.get(AuthenticationService);
    }

    public autoLogin = async (
        autoLoginModel: IAutoLoginModel,
    ): Promise<IAuthenticationResult<IAutoLoginResponseModel>> => {
        const result: IAuthenticationResult<IAutoLoginResponseModel> =
            await this._authenticationService.autoLogin(autoLoginModel);

        const { response, errorResponse } = result;

        if (response?.Response?.BearerToken) {
            this._saveSourceProductPackage();
            await this._authenticationService.continuePostLoginActions(response);
        } else {
            await this.onLoginFail(response, errorResponse);
        }

        return result;
    };

    protected async onLoginFail(
        response: IEnhancedLoginResult<IAutoLoginResponseModel>,
        errorResponse: any,
    ): Promise<void> {
        await this._pokerNative.onAutologinFailed();
    }

    private _saveSourceProductPackage = () => {
        const sourceProductPackage = this._urlUtils.getParameterByName('SourceProductPackage');

        if (sourceProductPackage) {
            const brandId = this._window.pageContextManager.getBrandData().brandId;
            const isGeoLocationBrand = GeoLocationBrands.some((x) => x === brandId);

            if (isGeoLocationBrand)
                this._sessionSimpleStoreService.set(
                    StorageItemEnum.AutoLoginSourceProductPackage,
                    sourceProductPackage,
                );
        }
    };
}
